import Vue from 'vue'

import moment from 'moment'

function init() {
    Vue.filter('formatTime', (val) => {
        return moment(val).format('HH:mm');
    });

    Vue.filter('formatDate', (val) => {
        return moment(val).format('DD.MM.YYYY');
    });
}

export default {
    init
}